'use client';

import StandardPostPage from './StandardPostPage';

export default function EventPageClient() {
  return (
    <StandardPostPage
      title="Events"
      description="Latest events and activities from LJPR"
      postType="event"
    />
  );
}
